import { trans } from "@mongez/localization";

type AboutUsSchemaType = {
  originUrl: string;
  aboutUsUrl: string;
  pageName?: string;
};

type AboutUsBreadcrumbSchemaType = {
  originUrl: string;
  aboutUsUrl: string;
};

export const aboutUsSchema = ({
  originUrl,
  aboutUsUrl,
  pageName,
}: AboutUsSchemaType) => {
  return {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    "@id": `${aboutUsUrl}#aboutpage`,
    url: aboutUsUrl,
    name: pageName || trans("aboutUs"),
    description: trans("aboutUsDescription") || "",
    inLanguage: originUrl.includes("/ar") ? "ar" : "en",
    publisher: {
      "@type": "Organization",
      "@id": `${originUrl}/#organization`,
    },
    mainEntity: {
      "@type": "Organization",
      "@id": `${originUrl}/#organization`,
    },
  };
};

export const aboutUsBreadcrumbSchema = ({
  originUrl,
  aboutUsUrl,
}: AboutUsBreadcrumbSchemaType) => {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: trans("home"),
        item: originUrl,
      },
      {
        "@type": "ListItem",
        position: 2,
        name: trans("aboutUs"),
        item: aboutUsUrl,
      },
    ],
  };
};
